import * as React from "react";
import {useEffect} from "react";
// import {FeatureContext} from "./context/FeatureProvider";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {LandingPageScreen} from "./pages/LandingPageScreen";
import {Login} from "./pages/Login";
import {Information} from "./pages/Information";
import {PersonalProfile} from "./pages/PersonalProfile";
import {PublicProfile} from "./pages/PublicProfile";
import {Kulavruksh} from "./pages/Kulavruksh";
import {Register} from "./pages/Register";
import {Chapter1} from "./pages/Chapter1";
import {Chapter2} from "./pages/Chapter2";
import {Chapter3} from "./pages/Chapter3";
import {Chapter4} from "./pages/Chapter4";
import {CommitteeProceedings} from "./pages/CommitteeProceedings";
import {StatutesAndRegulations} from "./pages/StatutesAndRegulations";
import {Chapter7} from "./pages/Chapter7";
import {Chapter8} from "./pages/Chapter8";
import {Chapter9} from "./pages/Chapter9";
import {Chapter10} from "./pages/Chapter10";
import {Chapter11} from "./pages/Chapter11";
import {Chapter12} from "./pages/Chapter12";
import {Chapter13} from "./pages/Chapter13";
import {Chapter14} from "./pages/Chapter14";
import {Chapter15} from "./pages/Chapter15";
import {Chapter16} from "./pages/Chapter16";
import {Chapter17} from "./pages/Chapter17";
import {Chapter18} from "./pages/Chapter18";
import {Chapter19} from "./pages/Chapter19";
import {AdvancedSearchPage} from "./pages/AdvancedSearchPage";
import {PhotoGallery} from "./pages/PhotoGallery";
import {BestWishes} from "./pages/BestWishes";
import {RemembranceDay} from "./pages/RemembranceDay";
import {Pride} from "./pages/Pride";
import {Religious} from "./pages/Religious";
import {NewsAndEvents} from "./pages/NewsAndEvents";
import {HelpEachOther} from "./pages/HelpEachOther";
import {HappyToShare} from "./pages/HappyToShare";
import {AnurupJodidar} from "./pages/AnurupJodidar";
import {Membership} from "./pages/Membership";
import {Chapter21} from "./pages/Chapter21";
import {Contact} from "./pages/Contact";
import {Chapter20} from "./pages/Chapter20";
import {Ambajogai} from "./pages/Ambajogai";
import {Arti} from "./pages/Arti";
import {Mantropchar} from "./pages/Mantropchar";
import {Kulachar} from "./pages/Kulachar";
import {Vyadeshwar} from "./pages/Vyadeshwar";
import {KulvrutantSamiti} from "./pages/KulvrtantSamiti";
import {YogeshwariMantropchar} from "./pages/YogeshwariMantropchar";
import {YogeshwariAarti} from "./pages/YogeshwariAarti";
import AnnualReports from "./components/AnnualReports";
import PresidentsThoughts from "./pages/PresidentsThoughts";
import OnboardingTutorials from "./components/OnboardingTutorials";

import {Dashboard} from "./pages/super-user/Dashboard";
import {NatureWarriors} from "./pages/NatureWarriors";
import {ShatayushiMembers} from "./pages/ShatayushiMembers";
import {Memories} from "./pages/Memories";
import {useAuth} from "./hooks/useAuth";
import Assistant from "./pages/Assistant";
import YellowPagesLandingStatic from "./pages/yellow-pages-static/YellowPagesLandingStatic";
import YellowPagesSearchStatic from "./pages/yellow-pages-static/YellowPagesSearchStatic";
import YellowPagesLayout from "@/pages/YellowPagesLayout";
import YellowPagesHomePage from "@/pages/YellowPagesHomePage";
import {YellowPagesSearchPage} from "@/pages/YellowPagesSearchPage";
import {YellowPageEntityProfile} from "@/components/YellowPageEntityProfile";

export default function App() {
	const {isAuthenticated, isAdmin, loading, redirectTo} = useAuth();
	const location = window.location;

	useEffect(() => {
		console.log("(App.jsx) Location: ", location);
	}, [])

	if (loading) {
		return (
			<div className={"w-[100vw] h-[100vh] bg-[#F7F7F7] flex items-center justify-center"}>
				<h1 className={"text-[5vw] font-custom-mono-bold"}>
					Loading...
				</h1>
			</div>
		)
	}

	return (
		<>
			<BrowserRouter basename={"/"}>
				<Routes>
					<Route
						path="/super-user/dashboard"
						element={isAuthenticated && isAdmin
							? <Dashboard/>
							: <Navigate to="/home" replace/>}
					/>

					{/* Public Routes */}
					<Route path="/home" element={<LandingPageScreen/>}/>
					<Route path="/search" element={<AdvancedSearchPage/>}/>
					<Route path="/info" element={<Information/>}/>
					<Route path="/contact" element={<Contact/>}/>
					<Route path="/pride" element={<Pride/>}/>
					<Route path="/membership" element={<Membership/>}/>
					<Route path="/religious" element={<Religious/>}/>
					<Route path="/ambajogai" element={<Ambajogai/>}/>
					<Route path="/aarti" element={<Arti/>}/>
					<Route path="/mantropchar" element={<Mantropchar/>}/>
					<Route path="/kulachar" element={<Kulachar/>}/>
					<Route path="/vyadeshwar" element={<Vyadeshwar/>}/>
					<Route path="/kulvruttant-samiti" element={<KulvrutantSamiti/>}/>
					<Route path="/yogeshwari-devi-mantropchar" element={<YogeshwariMantropchar/>}/>
					<Route path="/yogeshwari-devi-aarti" element={<YogeshwariAarti/>}/>
					<Route path="/manogat" element={<PresidentsThoughts/>}/>
					<Route path="/onboarding-tutorials" element={<OnboardingTutorials/>}/>
					<Route path="/nature-warriors" element={<NatureWarriors/>}/>
					<Route path="/shatayushi-members" element={<ShatayushiMembers/>}/>
					<Route path="/yellow-pages-static" element={<YellowPagesLandingStatic/>}/>
					<Route path="/yellow-pages-static/search" element={<YellowPagesSearchStatic/>}/>

					{/* Protected Routes | Authentication Required */}
					<Route path="/kulavruksh" element={<Kulavruksh/>}/>

					<Route element={<YellowPagesLayout/>}>
						<Route path="/yellow-pages" element={<YellowPagesHomePage/>}/>
						<Route path="/yellow-pages/search" element={<YellowPagesSearchPage/>}/>
						<Route path="/yellow-pages/:entityId" element={<YellowPageEntityProfile/>}/>
					</Route>

					{/*<Route path="/yellow-page" element={<YellowPagesHomePage/>}/>*/}
					{/*<Route path="/yellow-page-entity-public-profile" element={<YellowPageEntityPublicProfile/>}/>*/}
					{/*<Route path="/yellow-page-entity-profile" element={<YellowPageEntityProfile/>}/>*/}
					{/*<Route path="/yellow-page-search-results" element={<YellowPagesSearchPage/>}/>*/}

					<Route path="/photo-gallery" element={<PhotoGallery/>}/>
					<Route path="/best-wishes" element={<BestWishes/>}/>
					<Route path="/remembrance-day" element={<RemembranceDay/>}/>
					<Route path="/memories" element={<Memories/>}/>
					<Route path="/news-and-events" element={<NewsAndEvents/>}/>
					<Route path="/help-each-other" element={<HelpEachOther/>}/>
					<Route path="/happy-to-share" element={<HappyToShare/>}/>
					<Route path="/anuroop-jodidar" element={<AnurupJodidar/>}/>
					<Route path="/annual-reports" element={<AnnualReports/>}/>
					<Route path="/proceedings" element={<CommitteeProceedings/>}/>
					<Route path="/statutes-and-regulations" element={<StatutesAndRegulations/>}/>

					{/* Chapter Routes */}
					<Route path="/chapter1" element={<Chapter1/>}/>
					<Route path="/chapter2" element={<Chapter2/>}/>
					<Route path="/chapter3" element={<Chapter3/>}/>
					<Route path="/chapter4" element={<Chapter4/>}/>
					{/*<Route path="/proceedings" element={<CommitteeProceedings/>}/>*/}
					{/*<Route path="/statutes-and-regulations" element={<StatutesAndRegulations/>}/>*/}
					<Route path="/chapter7" element={<Chapter7/>}/>
					<Route path="/chapter8" element={<Chapter8/>}/>
					<Route path="/chapter9" element={<Chapter9/>}/>
					<Route path="/chapter10" element={<Chapter10/>}/>
					<Route path="/chapter11" element={<Chapter11/>}/>
					<Route path="/chapter12" element={<Chapter12/>}/>
					<Route path="/chapter13" element={<Chapter13/>}/>
					<Route path="/chapter14" element={<Chapter14/>}/>
					<Route path="/chapter15" element={<Chapter15/>}/>
					<Route path="/chapter16" element={<Chapter16/>}/>
					<Route path="/chapter17" element={<Chapter17/>}/>
					<Route path="/chapter18" element={<Chapter18/>}/>
					<Route path="/chapter19" element={<Chapter19/>}/>
					<Route path="/chapter20" element={<Chapter20/>}/>
					<Route path="/chapter21" element={<Chapter21/>}/>

					{/* Conditional Routes */}
					<Route
						path="/login"
						element={!isAuthenticated
							? <Login/>
							: <Navigate to="/home" replace/>}
					/>
					<Route
						path="/register"
						element={!isAuthenticated
							? <Register/>
							: <Navigate to={redirectTo ? redirectTo : "/home"} replace/>}
					/>

					<Route
						path="/personal-profile"
						element={isAuthenticated
							? <PersonalProfile/>
							: <Navigate to="/login" replace/>}
					/>
					<Route
						path="/public-profile/:id"
						element={isAuthenticated
							? <PublicProfile/>
							: <Navigate to="/login" replace/>}
					/>

					<Route path="*" element={<Navigate to="/home" replace/>}/>
				</Routes>
			</BrowserRouter>

			<Assistant
				hiddenOnRoutes={[
					'/super-user',
					'/yellow-pages',
					'/login',
					'/register',
				]}
			/>
		</>
	);
}
